/* eslint-disable max-lines */
import { CFTokens } from '../../../../tokens';
export const COLORS = {
    BACKGROUND: {
        boost: CFTokens.COLOR.INTERACTIVE_BOOST,
        'boost-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_BOOST,
        control: 'transparent',
        'control-active': CFTokens.COLOR.BACKGROUND_WARM_1,
        'control-active-alternate': CFTokens.COLOR.INTERACTIVE_ALTERNATE_DEFAULT,
        'control-alternate': 'transparent',
        danger: CFTokens.COLOR.CHROMATIC_STRAWBERRY_DEFAULT,
        'danger-alternate': CFTokens.COLOR.INTERACTIVE_ALTERNATE_DEFAULT,
        'danger-secondary': 'transparent',
        'danger-secondary-alternate': 'transparent',
        'danger-tertiary': 'transparent',
        'danger-tertiary-alternate': 'transparent',
        emphasis: CFTokens.COLOR.INTERACTIVE_EMPHASIS,
        'emphasis-tertiary': 'transparent',
        primary: CFTokens.COLOR.INTERACTIVE_DEFAULT,
        'primary-alternate': CFTokens.COLOR.INTERACTIVE_ALTERNATE_DEFAULT,
        secondary: 'transparent',
        'secondary-alternate': 'transparent',
        standalone: 'transparent',
        'standalone-alternate': 'transparent',
        'standalone-emphasis': 'transparent',
        subtle: CFTokens.COLOR.INTERACTIVE_SUBTLE,
        'subtle-warm': CFTokens.COLOR.BACKGROUND_WARM_1,
        success: CFTokens.COLOR.CHROMATIC_FOREST_DEFAULT,
        'success-alternate': CFTokens.COLOR.INTERACTIVE_ALTERNATE_DEFAULT,
        'success-secondary': 'transparent',
        'success-secondary-alternate': 'transparent',
        'success-tertiary': 'transparent',
        'success-tertiary-alternate': 'transparent',
        tertiary: 'transparent',
        'tertiary-alternate': 'transparent',
    },
    BACKGROUND_DISABLED: {
        boost: CFTokens.COLOR.INTERACTIVE_DISABLED,
        'boost-alternate': CFTokens.COLOR.INTERACTIVE_ALTERNATE_DISABLED,
        control: 'transparent',
        'control-active': 'transparent',
        'control-active-alternate': CFTokens.COLOR.INTERACTIVE_ALTERNATE_DISABLED,
        'control-alternate': 'transparent',
        danger: CFTokens.COLOR.INTERACTIVE_DISABLED,
        'danger-alternate': CFTokens.COLOR.INTERACTIVE_ALTERNATE_DISABLED,
        'danger-secondary': 'transparent',
        'danger-secondary-alternate': 'transparent',
        'danger-tertiary': 'transparent',
        'danger-tertiary-alternate': 'transparent',
        emphasis: CFTokens.COLOR.INTERACTIVE_DISABLED,
        'emphasis-tertiary': 'transparent',
        primary: CFTokens.COLOR.INTERACTIVE_DISABLED,
        'primary-alternate': CFTokens.COLOR.INTERACTIVE_ALTERNATE_DISABLED,
        secondary: 'transparent',
        'secondary-alternate': 'transparent',
        standalone: 'transparent',
        'standalone-alternate': 'transparent',
        'standalone-emphasis': 'transparent',
        subtle: CFTokens.COLOR.INTERACTIVE_DISABLED,
        'subtle-warm': CFTokens.COLOR.INTERACTIVE_DISABLED,
        success: CFTokens.COLOR.INTERACTIVE_DISABLED,
        'success-alternate': CFTokens.COLOR.INTERACTIVE_ALTERNATE_DISABLED,
        'success-secondary': 'transparent',
        'success-secondary-alternate': 'transparent',
        'success-tertiary': 'transparent',
        'success-tertiary-alternate': 'transparent',
        tertiary: 'transparent',
        'tertiary-alternate': 'transparent',
    },
    BACKGROUND_HOVER: {
        boost: CFTokens.COLOR.INTERACTIVE_HOVER_DEFAULT,
        'boost-alternate': CFTokens.COLOR.FOREST_3,
        control: CFTokens.COLOR.INTERACTIVE_HOVER_SECONDARY,
        'control-active': CFTokens.COLOR.INTERACTIVE_HOVER_SECONDARY,
        'control-active-alternate': CFTokens.COLOR.INTERACTIVE_ALTERNATE_HOVER_DEFAULT,
        'control-alternate': CFTokens.COLOR.INTERACTIVE_ALTERNATE_HOVER_SECONDARY,
        danger: CFTokens.COLOR.CHROMATIC_STRAWBERRY_CONTRAST,
        'danger-alternate': CFTokens.COLOR.STRAWBERRY_1,
        'danger-secondary': CFTokens.COLOR.STRAWBERRY_1,
        'danger-secondary-alternate': CFTokens.COLOR.SALT_24,
        'danger-tertiary': CFTokens.COLOR.STRAWBERRY_1,
        'danger-tertiary-alternate': CFTokens.COLOR.SALT_24,
        emphasis: CFTokens.COLOR.INTERACTIVE_HOVER_DEFAULT,
        'emphasis-tertiary': CFTokens.COLOR.INTERACTIVE_HOVER_SECONDARY,
        primary: CFTokens.COLOR.INTERACTIVE_HOVER_DEFAULT,
        'primary-alternate': CFTokens.COLOR.INTERACTIVE_ALTERNATE_HOVER_DEFAULT,
        secondary: CFTokens.COLOR.INTERACTIVE_HOVER_SECONDARY,
        'secondary-alternate': CFTokens.COLOR.INTERACTIVE_ALTERNATE_HOVER_SECONDARY,
        standalone: 'transparent',
        'standalone-alternate': 'transparent',
        'standalone-emphasis': 'transparent',
        subtle: CFTokens.COLOR.INTERACTIVE_HOVER_SUBTLE,
        'subtle-warm': CFTokens.COLOR.BACKGROUND_WARM_2,
        success: CFTokens.COLOR.BACKGROUND_BRAND_DARK,
        'success-alternate': CFTokens.COLOR.FOREST_1,
        'success-secondary': CFTokens.COLOR.FOREST_1,
        'success-secondary-alternate': CFTokens.COLOR.SALT_24,
        'success-tertiary': CFTokens.COLOR.FOREST_1,
        'success-tertiary-alternate': CFTokens.COLOR.SALT_24,
        tertiary: CFTokens.COLOR.INTERACTIVE_HOVER_SECONDARY,
        'tertiary-alternate': CFTokens.COLOR.INTERACTIVE_ALTERNATE_HOVER_SECONDARY,
    },
    BORDER: {
        boost: 'transparent',
        'boost-alternate': 'transparent',
        control: CFTokens.COLOR.BORDER_DEFAULT,
        'control-active': CFTokens.COLOR.BORDER_STRONG,
        'control-active-alternate': 'transparent',
        'control-alternate': CFTokens.COLOR.SALT_64,
        danger: 'transparent',
        'danger-alternate': 'transparent',
        'danger-secondary': CFTokens.COLOR.CHROMATIC_STRAWBERRY_DEFAULT,
        'danger-secondary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DANGER,
        'danger-tertiary': 'transparent',
        'danger-tertiary-alternate': 'transparent',
        emphasis: 'transparent',
        'emphasis-tertiary': 'transparent',
        primary: 'transparent',
        'primary-alternate': 'transparent',
        secondary: CFTokens.COLOR.BORDER_STRONG,
        'secondary-alternate': CFTokens.COLOR.BORDER_ALTERNATE_STRONG,
        standalone: 'transparent',
        'standalone-alternate': 'transparent',
        'standalone-emphasis': 'transparent',
        subtle: 'transparent',
        'subtle-warm': 'transparent',
        success: 'transparent',
        'success-alternate': 'transparent',
        'success-secondary': CFTokens.COLOR.CHROMATIC_FOREST_DEFAULT,
        'success-secondary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_SUCCESS,
        'success-tertiary': 'transparent',
        'success-tertiary-alternate': 'transparent',
        tertiary: 'transparent',
        'tertiary-alternate': 'transparent',
    },
    BORDER_DISABLED: {
        boost: 'transparent',
        'boost-alternate': 'transparent',
        control: CFTokens.COLOR.BORDER_DISABLED,
        'control-active': CFTokens.COLOR.BORDER_DISABLED,
        'control-active-alternate': 'transparent',
        'control-alternate': CFTokens.COLOR.BORDER_ALTERNATE_DISABLED,
        danger: 'transparent',
        'danger-alternate': 'transparent',
        'danger-secondary': CFTokens.COLOR.BORDER_DISABLED,
        'danger-secondary-alternate': CFTokens.COLOR.BORDER_ALTERNATE_DISABLED,
        'danger-tertiary': 'transparent',
        'danger-tertiary-alternate': 'transparent',
        emphasis: 'transparent',
        'emphasis-tertiary': 'transparent',
        primary: 'transparent',
        'primary-alternate': 'transparent',
        secondary: CFTokens.COLOR.BORDER_DISABLED,
        'secondary-alternate': CFTokens.COLOR.BORDER_ALTERNATE_DISABLED,
        standalone: 'transparent',
        'standalone-alternate': 'transparent',
        'standalone-emphasis': 'transparent',
        subtle: 'transparent',
        'subtle-warm': 'transparent',
        success: 'transparent',
        'success-alternate': 'transparent',
        'success-secondary': CFTokens.COLOR.BORDER_DISABLED,
        'success-secondary-alternate': CFTokens.COLOR.BORDER_ALTERNATE_DISABLED,
        'success-tertiary': 'transparent',
        'success-tertiary-alternate': 'transparent',
        tertiary: 'transparent',
        'tertiary-alternate': 'transparent',
    },
    FOCUS: {
        ALTERNATE: CFTokens.COLOR.INTERACTIVE_ALTERNATE_DEFAULT,
        BOOST_ALTERNATE: CFTokens.COLOR.TEXT_AND_ELEMENT_BOOST,
        CONTROL: CFTokens.COLOR.BORDER_DEFAULT,
        CONTROL_ALTERNATE: CFTokens.COLOR.SALT_64,
        DANGER: CFTokens.COLOR.CHROMATIC_STRAWBERRY_DEFAULT,
        DANGER_ALTERNATE: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DANGER,
        DEFAULT: CFTokens.COLOR.INTERACTIVE_FOCUS_PRIMARY,
        DISABLED: 'transparent',
        EMPHASIS: CFTokens.COLOR.INTERACTIVE_FOCUS_EMPHASIS,
        SUCCESS: CFTokens.COLOR.CHROMATIC_FOREST_DEFAULT,
        SUCCESS_ALTERNATE: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_SUCCESS,
    },
    TEXT: {
        boost: CFTokens.COLOR.TEXT_AND_ELEMENT_BOOST,
        'boost-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_BRAND,
        control: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        'control-active': CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        'control-active-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        'control-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DEFAULT,
        danger: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
        'danger-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_DANGER,
        'danger-secondary': CFTokens.COLOR.TEXT_AND_ELEMENT_DANGER,
        'danger-secondary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DANGER,
        'danger-tertiary': CFTokens.COLOR.TEXT_AND_ELEMENT_DANGER,
        'danger-tertiary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DANGER,
        emphasis: CFTokens.COLOR.TEXT_AND_ELEMENT_ACCENT,
        'emphasis-tertiary': CFTokens.COLOR.TEXT_AND_ELEMENT_EMPHASIS,
        primary: CFTokens.COLOR.TEXT_AND_ELEMENT_ACCENT,
        'primary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        secondary: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        'secondary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DEFAULT,
        standalone: CFTokens.COLOR.TEXT_AND_ELEMENT_HINT,
        'standalone-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_HINT,
        'standalone-emphasis': CFTokens.COLOR.TEXT_AND_ELEMENT_EMPHASIS,
        'standalone-icon-only': CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        'standalone-icon-only-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DEFAULT,
        subtle: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        'subtle-warm': CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        success: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
        'success-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_SUCCESS,
        'success-secondary': CFTokens.COLOR.TEXT_AND_ELEMENT_SUCCESS,
        'success-secondary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_SUCCESS,
        'success-tertiary': CFTokens.COLOR.TEXT_AND_ELEMENT_SUCCESS,
        'success-tertiary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_SUCCESS,
        tertiary: CFTokens.COLOR.TEXT_AND_ELEMENT_HINT,
        'tertiary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_HINT,
    },
    TEXT_DISABLED: {
        boost: CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        'boost-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
        control: CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        'control-active': CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        'control-active-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
        'control-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
        danger: CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        'danger-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
        'danger-secondary': CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        'danger-secondary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
        'danger-tertiary': CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        'danger-tertiary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
        emphasis: CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        'emphasis-tertiary': CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        primary: CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        'primary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
        secondary: CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        'secondary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
        standalone: CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        'standalone-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
        'standalone-emphasis': CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        subtle: CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        'subtle-warm': CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        success: CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        'success-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
        'success-secondary': CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        'success-secondary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
        'success-tertiary': CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        'success-tertiary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
        tertiary: CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
        'tertiary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DISABLED,
    },
    TEXT_HOVER: {
        boost: CFTokens.COLOR.TEXT_AND_ELEMENT_BOOST,
        'boost-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_BRAND,
        control: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        'control-active': CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        'control-active-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        'control-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DEFAULT,
        danger: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
        'danger-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_DANGER,
        'danger-secondary': CFTokens.COLOR.TEXT_AND_ELEMENT_DANGER,
        'danger-secondary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DANGER,
        'danger-tertiary': CFTokens.COLOR.TEXT_AND_ELEMENT_DANGER,
        'danger-tertiary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DANGER,
        emphasis: CFTokens.COLOR.TEXT_AND_ELEMENT_ACCENT,
        'emphasis-tertiary': CFTokens.COLOR.TEXT_AND_ELEMENT_EMPHASIS,
        primary: CFTokens.COLOR.TEXT_AND_ELEMENT_ACCENT,
        'primary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        secondary: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        'secondary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DEFAULT,
        standalone: CFTokens.COLOR.LINK_SECONDARY_HOVER,
        'standalone-alternate': CFTokens.COLOR.LINK_ALTERNATE_SECONDARY_HOVER,
        'standalone-emphasis': CFTokens.COLOR.LINK_EMPHASIS_HOVER,
        subtle: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        'subtle-warm': CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        success: CFTokens.COLOR.TEXT_AND_ELEMENT_BOOST,
        'success-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_SUCCESS,
        'success-secondary': CFTokens.COLOR.TEXT_AND_ELEMENT_SUCCESS,
        'success-secondary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_SUCCESS,
        'success-tertiary': CFTokens.COLOR.TEXT_AND_ELEMENT_SUCCESS,
        'success-tertiary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_SUCCESS,
        tertiary: CFTokens.COLOR.TEXT_AND_ELEMENT_HINT,
        'tertiary-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_HINT,
    },
};
